<!-- <mat-accordion class="example-headers-align" multi displayMode="flat">
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>  {{ 'dashboard:Column Settings' | i18next }} </mat-panel-title>
        </mat-expansion-panel-header>
           content
      </mat-expansion-panel>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>  {{ 'dashboard:Appearance' | i18next }} </mat-panel-title>
        </mat-expansion-panel-header>
           content
      </mat-expansion-panel>
</mat-accordion> -->

<div class="pref-header"> {{ 'dashboard:'+ (gridItem.type < 3 ?'Title Settings':'Column Settings') | i18next }}</div>
<div cdkDropList (cdkDropListDropped)="drop($event)" *ngIf="enableOrder" class="cdkDropList">
    <div *ngFor="let p of properties" cdkDrag class="settings-row">
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        <i class="fa fa-bars"></i>
        <input [(ngModel)]="p.name" (input)="onNameChanged(p)" [disabled]="gridItem.type == 4 || gridItem.type == 3">
        <i class="fa fa-undo" [style.opacity]="p.name==p.propName?'.2':'1'"
            (click)="p.name=p.propName;onNameChanged(p)"></i>
    </div>
</div>
<div *ngIf="!enableOrder" class="appearance-names">
    <div *ngFor="let a of appearance">
        <div *ngIf="a.editName">
            <div>{{ 'dashboard:'+a.label | i18next }}</div>
            <div class="settings-row">
                <input [(ngModel)]="a.name" (input)="onNameChanged({id:a.type,name:a.name,propName:a.defName})" maxlength="25" />
                <i class="fa fa-undo" [style.opacity]="a.name==a.defName?'.2':'1'"
                    (click)="a.name=a.defName;onNameChanged({id:a.type,name:a.name,propName:a.defName})"></i>
            </div>
        </div>
    </div>
</div>
<div class="pref-header"> {{ 'dashboard:Appearance' | i18next }}</div>
<div *ngFor="let a of appearance" class="appearance">
    {{ 'dashboard:'+a.label | i18next }}
    <div class="appearance-row">
        <span> {{ 'dashboard:Font Size' | i18next }}</span>
        <ng-select [items]="fontSizes" [(ngModel)]="a.fontSize" [class.active]="colorSchemeSelectOpened"
            bindLabel="name" bindValue="value" (change)="onFontSizeChanged($event,a)" [searchable]="false">
        </ng-select>
        <span> {{ 'dashboard:Color' | i18next }}</span>
        <div class="color" [style.background-color]="a.color" (click)="openColorPicker($event,a)"></div>
    </div>
</div>
